import Drawer from '@helsenorge/designsystem-react/components/Drawer';

export interface AppInvitationProps {
  /** Title text */
  title: string;
  /** Description text */
  description: string;
  /** The primary button text */
  primaryButtonText: string;
  /** Secondary button text */
  secondaryButtonText: string;
  /** Close button label */
  closeButtonLabel: string;
  /** The callback for handling closing the modal */
  onClose: () => void;
  /** The callback for handling opening the app */
  onAppOpen: () => void;
  /** The callback for handling regular login behaviour */
  onWebLogin: () => void;
  // Skal modalen være åpen eller lukket
  isOpen?: boolean;
}

const AppInvitation: React.FC<AppInvitationProps> = (props: AppInvitationProps) => {
  return (
    <Drawer
      isOpen={!!props.isOpen}
      title={props.title}
      primaryActionText={props.primaryButtonText}
      onPrimaryAction={props.onAppOpen}
      secondaryActionText={props.secondaryButtonText}
      onSecondaryAction={props.onWebLogin}
      onRequestClose={props.onClose}
    >
      {props.description}
    </Drawer>
  );
};

export default AppInvitation;
